module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-root"
  }, [_c('general-title', {
    attrs: {
      "title": "网站概况",
      "description": "帮助您整体了解网站运营情况，提供重点指标趋势图，包括各个时间维度下的相关指标趋势、访客来源、受访等宏观数据。帮助您了解网站的概括性数据。",
      "pos": "right",
      "date": _vm.timeSpan
    }
  }, [_c('div', {
    staticClass: "change-view-mode"
  }, [_c('a', {
    staticClass: "hover-link",
    class: {
      'mode-active': !_vm.isMultiMode
    },
    on: {
      "click": function($event) {
        _vm.toMultiMode(false)
      }
    }
  }, [_vm._v("单站查看")]), _c('span', {
    staticClass: "sep"
  }, [_vm._v("|")]), _c('a', {
    staticClass: "hover-link",
    class: {
      'mode-active': _vm.isMultiMode
    },
    on: {
      "click": function($event) {
        _vm.toMultiMode(true)
      }
    }
  }, [_vm._v("多站查看")])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isMultiMode),
      expression: "!isMultiMode"
    }]
  }, [_c('div', {
    staticClass: "zone",
    staticStyle: {
      "background": "transparent",
      "border": "0"
    }
  }, [_c('table', {
    staticClass: "data-table overview-table",
    staticStyle: {
      "table-layout": "fixed"
    }
  }, [_vm._m(0), _c('tbody', [_vm._l((_vm.surveyDataShown), function(row) {
    return _c('tr', {
      style: ({
        fontWeight: row.nameEn === 'today' ? 'bold' : 'normal'
      })
    }, [_c('td', {
      staticClass: "right"
    }, [_vm._v(_vm._s(row.nameCn)), _c('v-tooltip', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.nameCn == '今天'),
        expression: "row.nameCn == '今天'"
      }],
      attrs: {
        "tip": '今日数据按小时汇总，实时数据实时汇总，同时查看这两个数据可能存在差异',
        "pos": "right"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle",
      staticStyle: {
        "margin-left": "5px"
      }
    })])], 1), _c('td', {
      staticClass: "right"
    }, [_vm._v(_vm._s(row.pv))]), _c('td', {
      staticClass: "right"
    }, [_vm._v(_vm._s(row.uv))]), _c('td', {
      staticClass: "right"
    }, [_vm._v(_vm._s(row.ipnum))]), _c('td', {
      staticClass: "right"
    }, [_vm._v(_vm._s(row.newvst))]), _c('td', {
      staticClass: "right"
    }, [_vm._v(_vm._s(_vm._f("percent")(row.jrate)))]), _c('td', {
      staticClass: "right"
    }, [_vm._v(_vm._s(row.tnum))]), _c('td')])
  }), (_vm.surveyDataShown.length == 0 && _vm.surveyListLoaded) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("暂无数据")])]) : _vm._e(), (!_vm.surveyListLoaded) ? _c('tr', [_vm._m(1)]) : _vm._e()], 2)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.surveyList.length > 3),
      expression: "surveyList.length > 3"
    }],
    staticClass: "btn btn-toggle-arrow",
    class: _vm.surveyFullShown ? 'arrow-up' : 'arrow-down',
    on: {
      "click": _vm.toggoleSurveyData
    }
  })]), _c('timeSpan', {
    on: {
      "change": _vm.onTimespanChange
    }
  }), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-signal",
      "title": "趋势图"
    }
  }, [_c('IndiceCompare', {
    attrs: {
      "indicesMenu": _vm.indicesMenu,
      "indice": _vm.baseIndice,
      "compIndice": _vm.compareIndice
    },
    on: {
      "indiceChange": _vm.indiceChange
    }
  })], 1), _c('LineChart', {
    attrs: {
      "yAxis": _vm.yAxis,
      "legend": _vm.flowChartLegend,
      "xAxis": _vm.flowChartXAxis,
      "series": _vm.flowChartSeries
    }
  })], 1), _c('div', {
    staticClass: "zone top-zone"
  }, [_c('div', {
    staticClass: "top-zone-row"
  }, [_c('div', {
    staticClass: "top-zone-cell"
  }, [_c('div', {
    staticClass: "mr6"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-link",
      "title": "来源网站Top10"
    }
  }, [_c('a', {
    staticClass: "btn btn-icon pull-right",
    on: {
      "click": function($event) {
        _vm.goToSiteOrigin('origin')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("查看全部")])]), _c('table', {
    staticClass: "opt-table"
  }, [_vm._m(2), _c('tbody', _vm._l((_vm.topSources), function(item, index) {
    return _c('tr', [_c('td', {
      attrs: {
        "width": "56px"
      }
    }, [_c('p', {
      staticClass: "rank",
      class: ("rank_" + (index+1))
    }, [_vm._v(_vm._s(index + 1))])]), _c('td', [(item.refdomain !== '-') ? _c('a', {
      attrs: {
        "href": _vm._f("httpUrl")(item.refdomain),
        "title": item.refdomain,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.refdomain))]) : _vm._e(), (item.refdomain === '-') ? _c('span', [_vm._v(_vm._s(item.refdomain))]) : _vm._e()]), _c('td', {
      staticClass: "right"
    }, [_vm._v(_vm._s(item.pv))]), _c('td', {
      staticClass: "right"
    }, [_vm._v(_vm._s(_vm._f("percent")(item.rate)))])])
  }))])], 1)]), _c('div', {
    staticClass: "top-zone-cell"
  }, [_c('div', {
    staticClass: "ml6"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-ellipsis-h",
      "title": "搜索词Top10"
    }
  }, [_c('a', {
    staticClass: "btn btn-icon pull-right",
    on: {
      "click": function($event) {
        _vm.goTo('keyword')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("查看全部")])]), _c('table', {
    staticClass: "opt-table"
  }, [_vm._m(3), _c('tbody', _vm._l((_vm.topKeywords), function(item, index) {
    return _c('tr', [_c('td', {
      attrs: {
        "width": "56px"
      }
    }, [_c('p', {
      staticClass: "rank",
      class: ("rank_" + (index+1))
    }, [_vm._v(_vm._s(index + 1))])]), _c('td', [_vm._v(_vm._s(item.keyword))]), _c('td', {
      staticClass: "right"
    }, [_vm._v(_vm._s(item.pv))]), _c('td', {
      staticClass: "right"
    }, [_vm._v(_vm._s(_vm._f("percent")(item.rate)))])])
  }))])], 1)])]), _c('div', {
    staticClass: "top-zone-row"
  }, [_c('div', {
    staticClass: "top-zone-cell"
  }, [_c('div', {
    staticClass: "mr6"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-search",
      "title": "搜索引擎Top5"
    }
  }, [_c('a', {
    staticClass: "btn btn-icon pull-right",
    on: {
      "click": _vm.goToSEOrigin
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("查看全部")])]), _c('table', {
    staticClass: "data-table qhbar-table"
  }, [_vm._m(4), _c('tbody', _vm._l((_vm.topSearchEngines), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "pad-0"
    }, [_c('div', {
      staticClass: "percent-bar-con"
    }, [_c('div', {
      staticClass: "percent-bar",
      class: {
        'percent-bar-yellow': item.width
      },
      style: ({
        width: item.width + 'px'
      })
    }, [_vm._v(_vm._s(item.pv) + "(" + _vm._s(_vm._f("percent")(item.rate)) + ")")])])]), _c('td', {
      staticClass: "fff-divider"
    }, [(item.refdomain !== '-') ? _c('a', {
      attrs: {
        "href": _vm._f("httpUrl")(item.refdomain),
        "title": item.refdomain,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.refdomain))]) : _vm._e(), (item.refdomain === '-') ? _c('span', [_vm._v(_vm._s(item.refdomain))]) : _vm._e()])])
  }))])], 1)]), _c('div', {
    staticClass: "top-zone-cell"
  }, [_c('div', {
    staticClass: "ml6"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-bookmark",
      "title": "受访页面Top5"
    }
  }, [_c('a', {
    staticClass: "btn btn-icon pull-right",
    on: {
      "click": function($event) {
        _vm.goTo('page')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("查看全部")])]), _c('table', {
    staticClass: "data-table qhbar-table"
  }, [_vm._m(5), _c('tbody', _vm._l((_vm.topVisitedPages), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "pad-0"
    }, [_c('div', {
      staticClass: "percent-bar-con"
    }, [_c('div', {
      staticClass: "percent-bar",
      class: {
        'percent-bar-green': item.width
      },
      style: ({
        width: item.width + 'px'
      })
    }, [_vm._v(_vm._s(item.pv) + "(" + _vm._s(_vm._f("percent")(item.rate)) + ")")])])]), _c('td', {
      staticClass: "fff-divider"
    }, [(item.onurl !== '-') ? _c('a', {
      attrs: {
        "href": _vm._f("httpUrl")(item.onurl),
        "title": item.onurl,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.onurl))]) : _vm._e(), (item.onurl === '-') ? _c('span', [_vm._v(_vm._s(item.onurl))]) : _vm._e()])])
  }))])], 1)])]), _c('div', {
    staticClass: "top-zone-row"
  }, [_c('div', {
    staticClass: "top-zone-cell",
    attrs: {
      "width": "33.33333%"
    }
  }, [_c('div', {
    staticClass: "mr6"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-user",
      "title": "性别比例"
    }
  }, [_c('a', {
    staticClass: "btn btn-icon pull-right",
    on: {
      "click": function($event) {
        _vm.goTo('attributes')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("查看全部")])]), _c('PieChart', {
    attrs: {
      "legend": _vm.genderLegend,
      "series": _vm.genderSeries,
      "option": _vm.pieConf,
      "color": _vm.genderPieColors
    }
  })], 1)]), _c('div', {
    staticClass: "top-zone-cell",
    attrs: {
      "width": "33.33333%"
    }
  }, [_c('div', {
    staticClass: "mr6"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-leaf",
      "title": "年龄分布"
    }
  }, [_c('a', {
    staticClass: "btn btn-icon pull-right",
    on: {
      "click": function($event) {
        _vm.goTo('attributes')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("查看全部")])]), _c('PieChart', {
    attrs: {
      "legend": _vm.ageLegend,
      "series": _vm.ageSeries,
      "option": _vm.pieConf
    }
  })], 1)]), _c('div', {
    staticClass: "top-zone-cell",
    attrs: {
      "width": "33.33333%"
    }
  }, [_c('div', [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-map-marker",
      "title": "访客地域"
    }
  }, [_c('a', {
    staticClass: "btn btn-icon pull-right",
    on: {
      "click": function($event) {
        _vm.goTo('geodistrib')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("查看全部")])]), _c('MapChart', {
    attrs: {
      "name": "PV",
      "series": _vm.provSeries
    }
  })], 1)])])])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMultiMode),
      expression: "isMultiMode"
    }],
    staticClass: "multi-sites-view"
  }, [_vm._l((_vm.domainListSurvey), function(item) {
    return _c('div', {
      key: item.domain,
      staticClass: "site-survey"
    }, [_c('h2', [_c('a', {
      attrs: {
        "href": _vm._f("httpUrl")(item.domain.domain),
        "title": item.domain.domain
      }
    }, [_vm._v(_vm._s(_vm._f("ellipsis")(item.domain.domain, 80)))]), _c('a', {
      staticClass: "hover-link pull-right",
      on: {
        "click": function($event) {
          _vm.checkReport(item.domain)
        }
      }
    }, [_vm._v("查看报告")])]), _c('table', {
      staticClass: "data-table",
      staticStyle: {
        "table-layout": "fixed",
        "margin": "0"
      }
    }, [_vm._m(6, true), _c('tbody', [_vm._l((item.data), function(row) {
      return _c('tr', {
        style: ({
          fontWeight: row.nameEn === 'today' ? 'bold' : 'normal'
        })
      }, [_c('td', {
        staticClass: "tac-r"
      }, [_vm._v(_vm._s(row.nameCn))]), _c('td', [_vm._v(_vm._s(row.pv))]), _c('td', [_vm._v(_vm._s(row.uv))]), _c('td', [_vm._v(_vm._s(row.ipnum))]), _c('td', [_vm._v(_vm._s(row.newvst))]), _c('td', [_vm._v(_vm._s(_vm._f("percent")(row.jrate)))]), _c('td', [_vm._v(_vm._s(row.tnum))])])
    }), _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.data || !item.data.length),
        expression: "!item.data || !item.data.length"
      }]
    }, [_c('td', {
      staticStyle: {
        "text-align": "center",
        "background": "#fff"
      },
      attrs: {
        "colspan": "7"
      }
    }, [_vm._v("暂无数据")])])], 2)])])
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.multiListLoaded),
      expression: "!multiListLoaded"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "//p.ssl.qhimg.com/t010aba4345b02168d6.gif"
    }
  })])], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "100px"
    }
  }), _c('th', {
    staticClass: "right"
  }, [_vm._v("浏览量(PV)")]), _c('th', {
    staticClass: "right"
  }, [_vm._v("访客数(UV)")]), _c('th', {
    staticClass: "right"
  }, [_vm._v("IP数")]), _c('th', {
    staticClass: "right"
  }, [_vm._v("新独立访客")]), _c('th', {
    staticClass: "right"
  }, [_vm._v("跳出率")]), _c('th', {
    staticClass: "right"
  }, [_vm._v("转化次数")]), _c('th', {
    attrs: {
      "width": "50px"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_c('img', {
    attrs: {
      "src": "//p.ssl.qhimg.com/t010aba4345b02168d6.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "56px"
    }
  }), _c('th', [_vm._v("来源")]), _c('th', {
    staticClass: "right"
  }, [_vm._v("浏览量(PV)")]), _c('th', {
    staticClass: "right"
  }, [_vm._v("占比")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "56px"
    }
  }), _c('th', [_vm._v("搜索词")]), _c('th', {
    staticClass: "right"
  }, [_vm._v("浏览量(PV)")]), _c('th', {
    staticClass: "right"
  }, [_vm._v("占比")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("浏览量(PV)及占比")]), _c('th', {
    staticClass: "fff-divider"
  }, [_vm._v("搜索引擎")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("浏览量(PV)及占比")]), _c('th', {
    staticClass: "fff-divider"
  }, [_vm._v("受访页面")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _c('th', [_vm._v("浏览量(PV)")]), _c('th', [_vm._v("访客数(UV)")]), _c('th', [_vm._v("IP数")]), _c('th', [_vm._v("新独立访客")]), _c('th', [_vm._v("跳出率")]), _c('th', [_vm._v("转化次数")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-63db705a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63db705a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/overview.vue
// module id = 763
// module chunks = 0